module.exports = __webpack_public_path__ + "img/empty.4f9eb4b4.png";